import CopyToClipboard from './CopyToClipboard';
import UIStrings from '@/Utils/UIStrings';

function CopyUrlSection() {
    return (
        <div className="flex flex-col gap-3">
            <p className="text-muted-foreground text-sm md:text-base">
                {`${UIStrings.BookmarkingThisPageUseThisUrl}: `}
            </p>
            <CopyToClipboard />
        </div>
    );
}

export default CopyUrlSection;
